// extracted by mini-css-extract-plugin
export default {"modalityList":"ModalityList_modalityList__SCmQ1","modalityListItem":"ModalityList_modalityListItem__KXAjH"};